/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/434-npm': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 0v16h16V0H0zm13 13h-2V5H8v8H3V3h10v10z"/>'
  }
})
